import i18next from '../../config/i18next';
import i18nAttentionAlert from './i18n/fr.json';
import AttentionAlertsPage from './pages/attention-alerts-page/attention-alerts-page';
import CreateAttentionAlertPage from './pages/create-attention-alert-page/create-attention-alert-page';
import UpdateAttentionAlertPage from './pages/update-attention-alert-page/update-attention-alert-page';

i18next.addResourceBundle('fr', 'attention-alert', i18nAttentionAlert);

export { AttentionAlertsPage, CreateAttentionAlertPage, UpdateAttentionAlertPage };